import ImgStoryblok from 'components/ImgStoryblok'
import Text from 'components/Text'
import './LandingServicing.scss'

const LandingServicing = ({ blok }) => {
  return (
    <div className="landing_servicing_container">
      <div className="landing_servicing_container-logos">
        <ImgStoryblok
          src={blok.servicing_logo.filename}
          alt={blok.servicing_logo.alt}
          height="100%"
        />

        <span>+</span>

        <ImgStoryblok
          src={blok.recovery_logo.filename}
          alt={blok.recovery_logo.alt}
          height="100%"
        />
      </div>

      <div className="landing_servicing_container-texts">
        <Text
          h2
          size={1}
          className="landing_servicing_container-texts-primary_text"
        >
          {blok.primary_text}
        </Text>

        <div className="landing_servicing_container-texts-description">
          <Text
            p
            size={1}
            className="landing_servicing_container-texts-description-texts"
          >
            {blok.description_text}
          </Text>
          <a href={blok.link_text_url}>{blok.link_text}</a>
        </div>
      </div>
    </div>
  )
}

export default LandingServicing
